<script>
import FormValidation from '@/components/atoms/FormValidation'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox'
import policies from '@/modules/mixins/policies'

export default {
    name: 'Activate',

    components: {
        InputLine,
        InputCheckbox,
        ButtonLoader,
        FormValidation,
    },

    mixins: [policies],

    data() {
        return {
            loading: false,
            loaded: false,
            acceptTerms: false,
            acceptPrivacy: false,
            model: {
                email: null,
                accepted_terms_version: 1,
                accepted_privacy_version: 1,
                is_subscribed_for_newsletter: false,
            },
        }
    },

    mounted() {
        this.$set(this.model, 'accepted_privacy_version', this.config.privacy_version)
        this.$set(this.model, 'accepted_terms_version', this.config.terms_version)
    },

    methods: {
        activate() {
            this.loaded = false
            this.loading = true
            this.$user
                .activate(this.model)
                .then(() => {
                    this.loaded = true
                })
                .finally(() => {
                    this.loaded = true
                    this.loading = false
                })
        },
    },
}
</script>

<template lang="pug">
.container-fluid.container-lg
    .row
        .col-12.col-lg-4.offset-lg-4
            h1.mt-10.text-center {{ $t('labels.activate') }}
            p.lead.mb-5.text-center {{ $t('labels.activate_desc') }}
            form-validation(@submit="activate")
                input-line(type="email" v-model="model.email"  :placeholder="$t('labels.placeholder.email')")
                    | {{ $t('labels.email') }}
                input-checkbox.mb-1.mt-6.d-flex(v-model="acceptTerms" :content="$t('base.accept.terms', {link: terms})" required)
                input-checkbox.mb-1.d-flex(v-model="acceptPrivacy" :content="$t('base.accept.privacy', {link: privacy})" required)
                input-checkbox.d-flex(v-model="model.is_subscribed_for_newsletter" :content="$t('base.accept.newsletter')")
                template(v-slot:submit)
                    button-loader.btn.btn-primary.btn-block.mt-5.mb-2(type="submit" :loading="loading" inline) {{ $t('labels.send_instructions') }}
            transition(name="fade")
                .text-center(v-if="loaded")
                    p.lead {{ $t('labels.activate_info') }}
                    router-link(:to="{ name: 'restaurant-list' }") {{ $t('labels.check_restaurants') }}
</template>
